import { useEffect } from "react";

const Modal = ({
  isOpen = false,
  onClose,
  title = "",
  children,
  size = "md",
  closeOnOverlay = true,
  showCloseButton = true,
}) => {
  useEffect(() => {
    if (!isOpen) return;

    const originalOverflow = document.body.style.overflow;
    document.body.style.overflow = "hidden";

    const handleEscape = (event) => {
      if (event.key === "Escape" && onClose) {
        onClose();
      }
    };

    document.addEventListener("keydown", handleEscape);

    return () => {
      document.body.style.overflow = originalOverflow;
      document.removeEventListener("keydown", handleEscape);
    };
  }, [isOpen, onClose]);

  if (!isOpen) return null;

  const handleOverlayClick = () => {
    if (closeOnOverlay && onClose) {
      onClose();
    }
  };

  const handleContentClick = (e) => {
    e.stopPropagation();
  };

  return (
    <div
      className="ui-modal"
      role="dialog"
      aria-modal="true"
      aria-label={title || "Modal"}
      onClick={handleOverlayClick}
    >
      <div
        className={`ui-modal__content ui-modal__content--${size}`}
        onClick={handleContentClick}
      >
        <div className="ui-modal__header">
          <h3 className="ui-modal__title">{title}</h3>

          {showCloseButton && (
            <button
              type="button"
              className="ui-modal__close"
              onClick={onClose}
              aria-label="Tutup modal"
            >
              ✕
            </button>
          )}
        </div>

        <div className="ui-modal__body">{children}</div>
      </div>
    </div>
  );
};

export default Modal;